var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "-8 -8 528 528",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 512) scale(0.1 -0.1)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 180,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340 4469 c-160 -31 -299 -173 -330 -339 -14 -72 -14 -3068 0 -3140 15 -79 52 -153 106 -211 57 -60 113 -94 195 -120 59 -18 127 -19 1919 -19 1338 0 1874 3 1912 11 111 24 228 110 280 206 38 70 685 2009 693 2079 20 156 -60 324 -196 409 -82 53 -139 65 -296 65 l-143 0 0 128 c0 74 -6 152 -14 187 -34 143 -139 256 -284 306 -53 18 -100 19 -1081 19 l-1026 0 -200 201 c-110 110 -212 207 -227 215 -23 12 -126 14 -645 13 -340 -1 -638 -5 -663 -10z m1415 -400 c110 -110 212 -207 227 -215 23 -12 184 -14 1070 -14 989 0 1045 -1 1083 -19 51 -23 101 -74 117 -120 8 -21 13 -87 13 -161 l0 -125 -1650 -5 c-1281 -4 -1658 -8 -1686 -18 -61 -21 -155 -87 -192 -136 -19 -25 -46 -74 -61 -108 -14 -35 -123 -391 -241 -792 -118 -402 -218 -732 -220 -735 -3 -2 -5 543 -5 1212 0 859 3 1231 11 1268 15 69 85 143 150 157 26 6 283 10 614 11 l570 1 200 -201z m3020 -888 c80 -36 127 -107 128 -191 0 -33 -82 -294 -323 -1015 -177 -533 -331 -986 -341 -1007 -26 -52 -84 -96 -143 -108 -35 -7 -635 -9 -1887 -8 l-1836 3 -49 30 c-95 59 -118 -53 235 1136 200 677 321 1067 336 1090 14 22 44 47 76 63 l53 26 1855 0 c1779 0 1858 -1 1896 -19z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnit);
export default __webpack_public_path__ + "static/media/unit.e0128c7a542d8f58343e8f401f58ccb3.svg";
export { ForwardRef as ReactComponent };